import referenceDate from "../reference-date";
import sortByDates from "../sort-by-dates";

export default function getFutureDay(
  date, // May be `null` for current date.
  items,
) {
  // Ensure chronologically ascending sort order.
  sortByDates(items);

  const reference = referenceDate(date);
  return items.reduce((acc, cur) => {
    // Keep only future items.
    if (new Date(cur.date) <= reference) {
      return acc;
    }

    // Keep only the closest future item.
    if (acc) {
      return acc;
    }

    // -> Replace acc (null) by cur as soon as the condition matches.
    //    Do not change acc after its first assignment.
    return cur;
  }, null);
}
